import { CurrencyResponse } from 'src/models/organizations.models'
import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface QueryOrgCurrenciesOptions
  extends ExtendBaseQueryOptions<
    { currencies: CurrencyResponse[] },
    CurrencyResponse[]
  > {
  orgId: string | undefined
}

export const useQueryOrgCurrencies = ({
  orgId,
  enabled = true,
  ...rest
}: QueryOrgCurrenciesOptions) => {
  return useExtendQuery({
    queryKey: orgQueryKeys.currencies(orgId),
    queryUrl: () => `/organizations/${orgId}/currencies`,
    enabled: enabled && orgId !== undefined,
    select: (data) => {
      return data.currencies
    },
    ...rest,
  })
}
